import { useState } from "react";
import { useRoutePYM } from "../../../../hooks/useRoutePYM";
import { useConsecutivo } from "../../../../hooks/useConsecutivo";
import { useRoute } from "../../../../hooks/useRoute";
import { Page, Right, HeaderRow } from "../styles/component.style";
import { BtnGeneral } from "../../../../styles/Buttons";
import ModalRoutePYM from "../modals/ModalRoutePYM";
import SearchableSelect from "../../../../components/Common/SearchableSelect";

export default function RoutePYM() {
  const {
    form,
    setForm,
    saveRoutespym,
    getGroupByRoute,
    routeSelected,
    groups,
    getSubGruposByGrupo,
    groupSelected,
    subgroups,
    routeFilterSelected,
    groupsFilter,
    groupFilterSelected,
    subgroupsFilter,
    subgroupFilterSelected,
    consFilterSelected,
    loadRoutespym,
    routespym,
    setRoutespymEdit,
    empresasActivas,
  } = useRoutePYM();

  const [openModal, setOpenModal] = useState(false);

  const { consecutivos } = useConsecutivo();
  const { routes } = useRoute();

  const isActivo = (item) => {
    const val = item?.estado ?? item?.Estado;
    return val === 1 || val === "1" || val === true || val === "true";
  };

  const consActive = consecutivos.filter(isActivo);
  const routesActive = routes.filter(isActivo);
  const groupsActive = groups.filter(isActivo);
  const subgroupsActive = subgroups.filter(isActivo);

  const groupsFilterActive = groupsFilter.filter(isActivo);
  const subgroupsFilterActive = subgroupsFilter.filter(isActivo);

  const handleSave = async () => {
    const ok = await saveRoutespym();
    if (ok) {
      setOpenModal(false);
    }
  };

  return (
    <Page>
      <Right>
        {/* ================= HEADER ================= */}
        <HeaderRow>
          <h3>Filtrar Rutas PYM</h3>
          <BtnGeneral
            bg="gray"
            padding="6px 10px"
            radius="6px"
            fw="600"
            onClick={() => {
              setOpenModal(true);
              setRoutespymEdit(null);
            }}
          >
            Nuevo
          </BtnGeneral>
        </HeaderRow>

        {/* ================= FILTROS ================= */}
        <div style={{ display: "flex", gap: "20px" }}>
          <div style={{ flex: 1 }}>
            <label>Ruta</label>
            <SearchableSelect
              key={`filter-ruta-${routeFilterSelected || "empty"}`}
              value={routeFilterSelected ? String(routeFilterSelected) : ""}
              onValueChange={(val) => getGroupByRoute(val, 1)}
              options={routesActive.map((r) => ({
                value: String(r.id),
                label: `${r.codigo} - ${r.descripcion}`,
              }))}
              placeholder="Seleccione..."
              multiple={false}
              searchable={true}
              size="small"
              sx={{ mb: "12px", ...selectSx }}
            />
          </div>

          <div style={{ flex: 1 }}>
            <label>Grupo</label>
            <SearchableSelect
              key={`filter-grupo-${groupFilterSelected || "empty"}`}
              value={groupFilterSelected ? String(groupFilterSelected) : ""}
              onValueChange={(val) => getSubGruposByGrupo(val, 1)}
              disabled={!routeFilterSelected}
              options={groupsFilterActive.map((g) => ({
                value: String(g.id),
                label: `${g.codigo} - ${g.descripcion}`,
              }))}
              placeholder="Seleccione..."
              multiple={false}
              searchable={true}
              size="small"
              sx={{ mb: "12px", ...selectSx }}
            />
          </div>

          <div style={{ flex: 1 }}>
            <label>Subgrupo</label>
            <SearchableSelect
              key={`filter-subgrupo-${subgroupFilterSelected || "empty"}`}
              value={subgroupFilterSelected ? String(subgroupFilterSelected) : ""}
              onValueChange={(val) =>
                loadRoutespym(val, consFilterSelected)
              }
              disabled={!groupFilterSelected}
              options={subgroupsFilterActive.map((sg) => ({
                value: String(sg.id),
                label: `${sg.codigo} - ${sg.descripcion}`,
              }))}
              placeholder="Seleccione..."
              multiple={false}
              searchable={true}
              size="small"
              sx={{ mb: "12px", ...selectSx }}
            />
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <div style={{ flex: 1 }}>
            <label>Consecutivo</label>
            <SearchableSelect
              key={`filter-cons-${consFilterSelected || "empty"}`}
              value={consFilterSelected ? String(consFilterSelected) : ""}
              onValueChange={(val) =>
                loadRoutespym(subgroupFilterSelected, val)
              }
              options={consActive.map((c) => ({
                value: String(c.Consecutivo),
                label: `${c.Consecutivo} - ${c.Api}`,
              }))}
              placeholder="Seleccione..."
              multiple={false}
              searchable={true}
              size="small"
              sx={{ mb: "12px", ...selectSx }}
            />
          </div>
          <div style={{ flex: 1 }}></div>
          <div style={{ flex: 1 }}></div>
        </div>

        {/* ================= TABLA ================= */}
        <div
          style={{
            maxHeight: "350px",
            overflowY: "auto",
            border: "1px solid #e5e7eb",
            borderRadius: "6px",
          }}
        >
          <table style={tableStyle}>
            <thead
              style={{
                position: "sticky",
                top: 0,
                background: "#f8fafc",
                zIndex: 1,
              }}
            >
              <tr>
                <th style={{ ...thTdStyle, width: "280px" }}>Consecutivo</th>
                <th style={{ ...thTdStyle, width: "180px" }}>Subgrupo</th>
                <th style={{ ...thTdStyle, width: "220px" }}>Empresa</th>
                <th style={{ ...thTdStyle, textAlign: "center" }}>Sexo</th>
                <th style={thTdStyle}>Inicial</th>
                <th style={thTdStyle}>Final</th>
                <th style={thTdStyle}>Vigencia</th>
                <th style={{ ...thTdStyle, textAlign: "center" }}>Orden</th>
                <th style={{ ...thTdStyle, textAlign: "center" }}>Estado</th>
                <th style={{ ...thTdStyle, textAlign: "center" }}></th>
              </tr>
            </thead>

            <tbody>
              {routespym?.length > 0 ? (
                routespym.map((r) => (
                  <tr key={r.id}>
                    <td style={thTdStyle}>{r.Api}</td>
                    <td style={thTdStyle}>{r.subgrupo}</td>
                    <td style={thTdStyle}>{r.empresa_nombre || ""}</td>
                    <td style={{ ...thTdStyle, textAlign: "center" }}>
                      {r.Sexo}
                    </td>
                    <td style={thTdStyle}>{r.Inicial}</td>
                    <td style={thTdStyle}>{r.Final}</td>
                    <td style={thTdStyle}>{r.Vigencia}</td>
                    <td style={{ ...thTdStyle, textAlign: "center" }}>
                      {r.orden}
                    </td>
                    <td style={{ ...thTdStyle, textAlign: "center" }}>
                      {r.estado === "1" ? "Activo" : "Inactivo"}
                    </td>
                    <td style={{ ...thTdStyle, textAlign: "center" }}>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          setRoutespymEdit(r);
                          setOpenModal(true);
                        }}
                      >
                        ✏️
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="10"
                    style={{ textAlign: "center", padding: "12px" }}
                  >
                    No hay resultados
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Right>

      {/* ================= MODAL ================= */}
      <ModalRoutePYM
        open={openModal}
        onClose={() => setOpenModal(false)}
        form={form}
        setForm={setForm}
        saveRoutespym={handleSave}
        empresasActivas={empresasActivas}
        routesActive={routesActive}
        groupsActive={groupsActive}
        subgroupsActive={subgroupsActive}
        consActive={consActive}
        routeSelected={routeSelected}
        groupSelected={groupSelected}
        getGroupByRoute={getGroupByRoute}
        getSubGruposByGrupo={getSubGruposByGrupo}
        inputStyle={inputStyle}
      />
    </Page>
  );
}

/* ================= ESTILOS ================= */

const inputStyle = {
  width: "100%",
  padding: "6px",
  marginBottom: "12px",
  borderRadius: "6px",
  border: "1px solid #cbd5e1",
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
};

const thTdStyle = {
  border: "1px solid #e5e7eb",
  padding: "3px",
  fontSize: "14px",
};

const selectSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
    backgroundColor: "#ffffff",
    "& fieldset": { borderColor: "#cbd5e1" },
    "&:hover fieldset": { borderColor: "#94a3b8" },
    "&.Mui-focused fieldset": { borderColor: "#007bba" },
  },
  "& .MuiSelect-select": {
    padding: "6px 10px !important",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
  },
};
